<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          {{ t('lang.file_update_confirmation_title') }}
        </h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          {{ t('lang.file_update_confirmation_description') }}
        </p>
        <button
          type="button"
          class="close-button"
          data-testid="close-dialog"
          [disabled]="busy"
          [attr.aria-label]="t('lang.close')"
          (click)="stay.emit()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </header>

      <footer class="dialog-footer">
        <button
          #primaryButton
          type="button"
          class="primary-button"
          data-testid="update-files"
          cdkFocusInitial
          [disabled]="busy || !canUpdate"
          (click)="onUpdateFiles()">
          @if (busy) {
            <mzic-spinner />
          }
          {{ t(updateActionKey) | uppercase }}
        </button>
        <button
          type="button"
          class="secondary-button"
          data-testid="discard-changes"
          [disabled]="busy"
          (click)="onDiscardChanges()">
          {{ t(discardActionKey) | uppercase }}
        </button>
      </footer>
    </section>
  </div>
</ng-container>
